import { select, parseData } from "@assets/scripts/utils";
import TimelineMax from 'TimelineMax'

function stroke (element, options = {}) {
    const tl = new TimelineMax
    const params = parseData(element)

    return tl
        .pause()
        .delay(params.delay || 0)
        .fromTo(element, params.duration || 1, { drawSVG: 0 }, { drawSVG: '100%' })
}

function animateSVG(selector, animation, options) {
    const svg = select(selector)[0].contentDocument
    const elements = select('.stroke', svg)
    return elements.map(element => {
        return animation(element, options)
    })
}

window.addEventListener('load', e => {

    select('.article-card').forEach(element => {
        const obj = select('object', element)
        let animations = animateSVG(obj, stroke)

        element.addEventListener('mouseenter', e => {
            element.classList.add('animated')
            animations.forEach(a => a.restart())
        })
        element.addEventListener('mouseleave', e => {
            if(!animations) return
            // animations.forEach(a => a.clear())
            element.classList.remove('animated')
        })

        const delay = element.getAttribute('data-delay') || 0
        const tl = new TimelineMax

        tl
            .delay(Number(delay))
            .add(() => {
                element.classList.add('animated')
                animations.forEach(a => a.restart())
            })
            .to(element, 0, { className: '-=animated'}, 2)
            .repeat(-1)
            .repeatDelay(7)
    })
})
